import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { useStateMachine } from "little-state-machine";
import { Button } from "@components/Button";
import { useCheckoutState } from "@hooks/useCheckout";
import { resolveBundleAvailability } from "./lib/resolve-bundle-availability";
import { resolveButtonText } from "./lib/resolve-button-text";
import styles from "./styles/footer.module.css";

export function Footer({
  index,
  sections,
  handleScrollTo,
  totalPrice,
  totalCompareAtPrice,
  isStockup,
  discountMessage,
  handleSubmit,
}) {
  const { t } = useTranslation("bundles");
  const { state } = useStateMachine();
  const { loading } = useCheckoutState();

  const next = index < sections.length - 1 ? sections[index + 1].key : 0;

  if (isStockup) {
    return (
      <div className={styles.footer}>
        <div className={styles.buttonContainer}>
          {discountMessage && <p className={styles.message}>{discountMessage}</p>}
          <Button
            type="submit"
            handleClick={handleSubmit}
            description={"addBundleSetItem"}
            descriptionText={"Click to add stockup bundle item to cart"}
            isLoading={loading}
            isDisabled={!resolveBundleAvailability(sections, state)}
          >
            {t("add-bundle-button")}
            <span className={styles.price}>{totalPrice.replace(/[CA]/g, "")}</span>
            {totalCompareAtPrice && (
              <span className={styles.compareAtPrice}>
                {totalCompareAtPrice.replace(/[CA]/g, "")}
              </span>
            )}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.footer}>
      <div className={styles.buttonContainer}>
        {index === sections.length - 1 ? (
          <>
            {discountMessage && <p className={styles.message}>{discountMessage}</p>}
            <Button
              type="submit"
              handleClick={handleSubmit}
              description={"addMixAndMatchSet"}
              descriptionText={"Click to add set to cart"}
              isLoading={loading}
              isDisabled={!resolveBundleAvailability(sections, state)}
            >
              {t("add-set-button")}
              <span className={styles.price}> {totalPrice.replace(/[CA]/g, "")}</span>
              {totalCompareAtPrice && (
                <span className={styles.compareAtPrice}>
                  {totalCompareAtPrice.replace(/[CA]/g, "")}
                </span>
              )}
            </Button>
          </>
        ) : (
          <Button
            handleClick={() => handleScrollTo(next)}
            description={`scrollTo${index + 2}Product`}
            descriptionText={`Click to scroll to next product`}
            isDisabled={!state[`${sections[index].key}-variant`].availableForSale}
          >
            {`Add your ${resolveButtonText(index + 2)} product`}
          </Button>
        )}
      </div>
    </div>
  );
}

Footer.propTypes = {
  index: PropTypes.number.isRequired,
  sections: PropTypes.array.isRequired,
  handleScrollTo: PropTypes.func.isRequired,
  isStockup: PropTypes.bool.isRequired,
  discountMessage: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
};
